import globalVars from '@aon/aon-tws-common-ui/build/lib/globalVars.module.scss';
import { SeverityType } from '@aon/tws-common-ui-questions/build/lib/models';
import * as React from 'react';
import styled from 'styled-components';
import { SurveyStep } from '../../models';
import { WarningBox } from '../common/warnings';

export interface ISectionHeaderRowProps {
	propertyErrors: string[];
	propertyWarnings: string[];
	linkToWarnings?: SurveyStep;
	linkToErrors?: SurveyStep;
	text: string;
}

export const SectionHeader = styled.div`
	background-color: ${globalVars.mainGray};
	color: ${globalVars.white};
	border-radius: 4px 4px 0px 0px;
	padding: 16px 16px 16px 20px;
	border-left: ${globalVars.tertiaryBlue2} 10px solid;
	font-size: 16px;
`;
SectionHeader.displayName = 'SectionHeader';

export const SectionHeaderRow = (props: ISectionHeaderRowProps) => {
	const { propertyErrors, propertyWarnings, linkToErrors, linkToWarnings, text } = props;
	return (
		<>
			<SectionHeader>{text}</SectionHeader>
			{propertyWarnings.length > 0 && (
				<WarningBox severity={SeverityType.Warning} messages={propertyWarnings} linkToStep={linkToWarnings} />
			)}
			{propertyErrors.length > 0 && <WarningBox severity={SeverityType.Error} messages={propertyErrors} linkToStep={linkToErrors} />}
		</>
	);
};
